module.exports = __webpack_public_path__ + "img/Avatar-92.f8bd8a44.svg";